import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesClassesTaughtData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesTeacherSlice = createSlice({
  name: "archiveServicesTeacher",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
            
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesClassesTaughtData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesClassesTaughtData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesClassesTaughtData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesTeacherSlice.reducer;